import React, { createContext, useContext, useReducer } from "react";
import { initialFilterParks, initialSummary, raInitialFilterParks } from "../Data/parks";
import { parksReducer } from "../reducers/parksReducer";

//Create context
export const ParksContext = createContext();

//Initial state
const initialState = {
  parksData: [],
  summary: initialSummary,
  filters: initialFilterParks,
  pageIndex: 1, 
  animalSearch:'',
  parkSearch: '',
  filterdPark:[],
  selectedPark:0,
  //rare animal listing
  raParkData: [],
  raSummary:initialSummary,
  raFilters: raInitialFilterParks,
  raPageIndex: 1
};

//Provider
const ParksProvider = ({ children }) => {
  const [parksState, parksDispatch] = useReducer(parksReducer, initialState);
  return (
    <ParksContext.Provider
      value={{
        ...parksState,
        parksDispatch,
      }}
    >
      {children}
    </ParksContext.Provider>
  );
};

//hook
export const useParksContext = () => useContext(ParksContext);

export default ParksProvider;
